// package: gateway
// file: api-gateway.proto

var api_gateway_pb = require("./api-gateway_pb");
var google_protobuf_empty_pb = require("google-protobuf/google/protobuf/empty_pb");
var grpc = require("@improbable-eng/grpc-web").grpc;

var ApiGatewayService = (function () {
  function ApiGatewayService() {}
  ApiGatewayService.serviceName = "gateway.ApiGatewayService";
  return ApiGatewayService;
}());

ApiGatewayService.getCurrentVersion = {
  methodName: "getCurrentVersion",
  service: ApiGatewayService,
  requestStream: false,
  responseStream: false,
  requestType: google_protobuf_empty_pb.Empty,
  responseType: api_gateway_pb.VersionMetadata
};

exports.ApiGatewayService = ApiGatewayService;

function ApiGatewayServiceClient(serviceHost, options) {
  this.serviceHost = serviceHost;
  this.options = options || {};
}

ApiGatewayServiceClient.prototype.getCurrentVersion = function getCurrentVersion(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(ApiGatewayService.getCurrentVersion, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

exports.ApiGatewayServiceClient = ApiGatewayServiceClient;

